export enum TicketAttachmentDocumentType {
  IMG = 'IMG',
  PDF = 'PDF',
}
